(function () {
    'use strict';

    var cfg = window.ApollonOffcanvas;
    if (!cfg || !cfg.enabled || cfg.suppressed) return;

    var STORAGE_KEY = 'apollon_oc_autoopen_shown';
    var frequency = cfg.frequency || 'session';
    var delayMs = Math.max(1, parseInt(cfg.delay, 10) || 15) * 1000;

    // „Jednou za relaci" — pokud už bylo v této relaci zobrazeno, nespouštět znovu.
    if (frequency === 'session') {
        try {
            if (sessionStorage.getItem(STORAGE_KEY) === '1') return;
        } catch (e) { /* sessionStorage nedostupné — pokračuj */ }
    }

    setTimeout(function () {
        var api = window.apollonOffcanvas;
        if (!api || typeof api.open !== 'function') return;

        // Neotevírat, pokud už uživatel nějaký offcanvas otevřel.
        if (api.isOpen()) return;

        api.open('contact');

        if (frequency === 'session') {
            try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (e) { /* ignore */ }
        }
    }, delayMs);
})();
